// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./accordion_ripple"
import * as bootstrap from "bootstrap"
import "./cart"
import "./turbo_stream_actions"
import "./gtm_turbo"

window.bootstrap = bootstrap;

//Turbo.session.drive = false;

// Back to Top
import {addBackToTop} from 'vanilla-back-to-top'

// Chatra - LiveChat
import Chatra from '@chatra/chatra';

const chatConfig = {
    setup: {
        buttonSize: 50,
        colors: {
            buttonText: '#ffffff',
            buttonBg: '#663399'
        }
    },
    ID: '7aowCmfBcjkAdYS2R'
}

const initChatra = () => {
    if (window._chatraInitialized) {
        // Re-init on Turbo navigations so Chatra can restart/re-attach if needed.
        Chatra('init', chatConfig);
        return;
    }

    Chatra('init', chatConfig);
    window._chatraInitialized = true;
}

const scheduleChatraInit = () => {
    if (window._chatraInitialized || window._chatraScheduled) return;

    window._chatraScheduled = true;
    const run = () => {
        window._chatraScheduled = false;
        initChatra();
    }

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, {timeout: 800});
    } else {
        setTimeout(run, 400);
    }
}

const bindChatraEarlyInteractionInit = () => {
    if (window._chatraInitialized || window._chatraInteractionBound) return;

    const events = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    const onFirstInteraction = () => {
        events.forEach((eventName) => {
            window.removeEventListener(eventName, onFirstInteraction);
        });

        window._chatraInteractionBound = false;
        initChatra();
    }

    window._chatraInteractionBound = true;
    events.forEach((eventName) => {
        window.addEventListener(eventName, onFirstInteraction, {passive: true});
    });
}

// Glightbox
import GLightbox from 'glightbox';

// noUiSlider - for range sliders
import noUiSlider from 'nouislider';

window.noUiSlider = noUiSlider;


document.addEventListener("turbo:load", () => {
    if (window._chatraInitialized) {
        initChatra();
    }

    bindChatraEarlyInteractionInit();
    scheduleChatraInit();

    addBackToTop({
        diameter: 50,
        backgroundColor: 'transparent',
        textColor: '#000'
    });

    const offcanvasElements = document.querySelectorAll('.offcanvas');
    offcanvasElements.forEach(offcanvasEl => {
        // Dispose of any existing instance
        const existingInstance = bootstrap.Offcanvas.getInstance(offcanvasEl);
        if (existingInstance) {
            existingInstance.dispose();
        }

        // Reinitialize
        new bootstrap.Offcanvas(offcanvasEl);
    });

    GLightbox({
        selector: ".lightbox",
        touchNavigation: true,
        showImageTitle: false,
        openEffect: 'zoom',
        closeEffect: 'fade',
        slideExtraAttributes: []
    });
});
